import * as R from 'ramda'
import React, { Component } from 'react'
import PouchDB from 'pouchdb-browser'
import domain from 'utils/domain'

// if (DEBUG) PouchDB.debug.enable('*')

export default class PouchSync extends Component {
    componentWillMount() {
    	// this.log('componentWillMount')
    	this.init(this.props)
  	}
  	componentWillReceiveProps(nextProps) {
    	// this.log('componentWillReceiveProps')
    	if (this.props.db1 !== nextProps.db1) {
    		this.cleanup()
			this.init(nextProps)
    	}
  	}
  	componentWillUnmount() {
    	// this.log('componentWillUnmount')
  		this.cleanup()
  	}
	init(props) {
    	this.log('init', props)
    	let { db1, db2 } = props
		let local = new PouchDB(db1, { size: 50, auto_compaction: true })
		let remote = new PouchDB(db2)
		let log = src => x => this.log(src, x)
		let error = src => x => {
			console.error('PouchSync(' + props.db1 + ')' + src, x)
			if (props.onError) props.onError(x)
		}
		let sync = () => {
			log('sync')()
			this.sync = PouchDB.sync(local, remote, {
				live: true
			  , retry: true
			  , batch_size: 10000
			  , timeout: 90000
			  , heartbeat: false
			})
			.on('active'  , log('active'))
			.on('change'  , log('change'))
			.on('denied'  , log('denied'))
			.on('paused'  , log('paused'))
			.on('complete', log('complete'))
			.on('error'   , error('sync'))
		}
		if (props.oneWay) {
			this.sync = local.replicate.to(remote, { live: true, retry: true })
			.on('error', error('replicate.to'))
		} else if (props.replicate) {
			log('replicate')()
			local.destroy().then(x => {
				local = new PouchDB(db1, { size: 50, auto_compaction: true })
				log('allDocs')()
				remote.allDocs({ include_docs: true })
				.then(x => {
					let docs = x.rows.map(x => x.doc)
					log('allDocs')(docs)
					let data = R.indexBy(R.prop('_id'), docs)
					log('onDownload')(data)
					props.onDownload(data)
					log('bulkDocs')()
					return local.bulkDocs(docs, { new_edits: false })
				})
				.then(log('onSave'))
				.then(props.onSave)
				.then(sync)
				.catch(error('load'))
			})
		} else {
			log('replicate.from')
			local.replicate.from(remote, {
				live: false
			  , retry: false
			  , batch_size: 10000
			})
			.then(log('onUpdate'))
			.then(props.onUpdate)
			.then(sync)
			.catch(error('replicate.from'))
		}
	}
	cleanup() {
    	this.log('cleanup')
	    if (this.sync) this.sync.cancel()
	}
	log(src, ...rest) {
		console.log('PouchSync(' + this.props.db1 + ').' + src, ...rest)
	}
  	render() {
  		return null
  	}
}



// WEBPACK FOOTER //
// ./src/components/drivers/PouchSync.js